import axios from "axios";
import { useAuth } from "@clerk/react";
import { useCallback, useEffect, useRef, useState } from "react";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function useApi() {
  const { getToken } = useAuth();
  const ref = useRef(getToken);
  ref.current = getToken;
  return useCallback(async (method, path, data, opts = {}) => {
    const token = await ref.current();
    const res = await axios({ method, url: `${API}${path}`, data, headers: { Authorization: `Bearer ${token}` }, ...opts });
    return res.data;
  }, []);
}

export function errMsg(e) {
  if (!navigator.onLine) return "Sei offline: serve una connessione.";
  const d = e?.response?.data?.detail;
  return typeof d === "string" ? d : "Qualcosa è andato storto. Riprova.";
}

export function useFetch(path) {
  const api = useApi();
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const reload = useCallback(async () => {
    try {
      setData(await api("get", path));
      setError(null);
    } catch (e) {
      setError(errMsg(e));
    }
  }, [api, path]);
  useEffect(() => { reload(); }, [reload]);
  return { data, error, reload, setData };
}
